/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useState, useMemo } from 'react';
import { CloseOutlined, StarFilled } from '@ant-design/icons';
import Style from './style';
import Widget from '../../widget';
import { mapData } from './helper';
import { RenderToggelableFlow, useNodes } from './flow';
import { openDSWindow } from '../../../../helpers/Window';

const colors = {
  supplyChainActor: '#52C41A',
  otherInformationSource: '#FF7875',
};

const defaultData = { location: {}, stakeholders: [] };

const StakeholderMapping = ({
  data = defaultData,
  isSingleSource = false,
  sources = {},
  mod = 'pme',
  loading,
  mode,
}) => {
  const mappedData = useMemo(() => mapData(data), [data]);
  const { t } = useTranslation();
  const [activeNode, setActiveNode] = useState(null);
  const {
    elements,
    onConnect,
    onElementsRemove,
    onLoad,
    initElements,
  } = useNodes({
    items: mappedData,
    type: 'LR',
    setActiveNode,
    t,
    activeNode,
  });

  const activeNodeRendered = useMemo(() => {
    if (activeNode) {
      const nodeSources = [];

      (activeNode.sources || []).forEach((s) => {
        const fT = sources?.featuredData?.find((S) => S.id === s);
        if (fT) {
          nodeSources.push({ ...fT, type: 'featuredData' });
        }
        const sP = sources?.supplyChainActor?.find((S) => S.id === s);
        if (sP) {
          nodeSources.push({ ...sP, type: 'supplyChainActor' });
        }
        const oI = sources?.otherInformationSources?.find((S) => S.id === s);
        if (oI) {
          nodeSources.push({ ...oI, type: 'otherInformationSource' });
        }
      });

      return (
        <div className="active-node">
          <div className="active-node-header">
            <div className="main">
              <label>{activeNode.group}</label>
              <h1>{activeNode.name}</h1>
            </div>
            <CloseOutlined
              onClick={() => setActiveNode(null)}
            />
          </div>
          {isSingleSource ? mode === 'proxy' ? (
            <Button
              className="w-100"
              type="link"
              onClick={() => {
                openDSWindow({
                  url: `/proxy/${mod}/view/stakeholder/${activeNode.id}`,
                  name: `DS Stakeholder ${activeNode.id}`,
                })
              }}
            >
              {t('View Details')}
            </Button>
          ) : (
            <Link
              to={`/app/${mod}/view/stakeholder/${activeNode.id}`}
              target="_blank"
            >
              <Button
                className="w-100"
                type="link"
              >
                {t('View Details')}
              </Button>
            </Link>
          ) : mode === 'proxy' ? (
            <div className="sources">
              <h3>{t('Sources reporting on subject:')}</h3>
              {nodeSources.map((s) => (
                <div className="source" key={`active-node-source-${s.id}`}>
                  <div className="source-header">
                    {s.type === 'featuredData' ? (
                      <StarFilled style={{ color: '#FFC700' }} />
                    ) : (
                      <div className="legend" style={{ background: colors[s.type] }} />
                    )}
                    <h4>{s.label}</h4>
                  </div>
                  <Button
                    type="link"
                    className="w-100"
                    onClick={() => {
                      openDSWindow({
                        url: `/proxy/${mod}/view/stakeholder/${activeNode.id}`,
                        name: `DS Stakeholder ${activeNode.id}`,
                      })
                    }}
                  >
                    {t('View Details')}
                  </Button>
                </div>
              ))}
            </div>
          ) : (
            <div className="sources">
              <h3>{t('Sources reporting on subject:')}</h3>
              {nodeSources.map((s) => (
                <div className="source" key={`active-node-source-${s.id}`}>
                  <div className="source-header">
                    {s.type === 'featuredData' ? (
                      <StarFilled style={{ color: '#FFC700' }} />
                    ) : (
                      <div className="legend" style={{ background: colors[s.type] }} />
                    )}
                    <h4>{s.label}</h4>
                  </div>
                  <Link
                    to={`/app/${mod}/view/stakeholder/${activeNode.id}?sourceId=${s.id}`}
                    target="_blank"
                  >
                    <Button
                      type="link"
                      className="w-100"
                    >
                      {t('View Details')}
                    </Button>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }
    return null;
  }, [activeNode, t, isSingleSource, sources]);

  return (
    <Widget
      loading={loading}
      className="full-header"
      title={t('Stakeholder Mapping')}
      tooltip={t('Stakeholders associated with this location')}
    >
      <Style style={{ height: 600 }}>
        <RenderToggelableFlow
          elements={elements}
          onElementsRemove={onElementsRemove}
          onConnect={onConnect}
          onLoad={onLoad}
          initElements={initElements}
          setActiveNode={setActiveNode}
        />
        {activeNodeRendered}
      </Style>
    </Widget>
  );
}

export default StakeholderMapping;
